import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "urq1srw3g__mask0_9484_43910",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          fill: "#C4C4C4",
          stroke: "#152361",
          strokeWidth: "2"
        })
      }), _jsxs("g", {
        mask: "url(#urq1srw3g__mask0_9484_43910)",
        children: [_jsx("path", {
          d: "M41 2H-11V28H41V2Z",
          fill: "#002395"
        }), _jsx("path", {
          d: "M2.78125 2H28.7812V28L2.78125 2Z",
          fill: "#FECB00"
        }), _jsx("path", {
          d: "M-3.35041 3.70323L-1.90091 -0.762268L-0.451406 3.70323L-4.25391 0.940732H0.445594L-3.35041 3.70323Z",
          fill: "white"
        }), _jsx("path", {
          d: "M-0.100406 6.95323L1.34909 2.48773L2.79859 6.95323L-1.00391 4.19073H3.69559L-0.100406 6.95323Z",
          fill: "white"
        }), _jsx("path", {
          d: "M3.14959 10.2032L4.59909 5.73773L6.04859 10.2032L2.24609 7.44073H6.94559L3.14959 10.2032Z",
          fill: "white"
        }), _jsx("path", {
          d: "M6.39959 13.4532L7.84909 8.98773L9.29859 13.4532L5.49609 10.6907H10.1956L6.39959 13.4532Z",
          fill: "white"
        }), _jsx("path", {
          d: "M9.6496 16.7032L11.0991 12.2377L12.5486 16.7032L8.74609 13.9407H13.4456L9.6496 16.7032Z",
          fill: "white"
        }), _jsx("path", {
          d: "M12.8996 19.9532L14.3491 15.4877L15.7986 19.9532L11.9961 17.1907H16.6956L12.8996 19.9532Z",
          fill: "white"
        }), _jsx("path", {
          d: "M16.1496 23.2032L17.5991 18.7377L19.0486 23.2032L15.2461 20.4407H19.9456L16.1496 23.2032Z",
          fill: "white"
        }), _jsx("path", {
          d: "M19.3996 26.4532L20.8491 21.9877L22.2986 26.4532L18.4961 23.6907H23.1956L19.3996 26.4532Z",
          fill: "white"
        }), _jsx("path", {
          d: "M22.6496 29.7032L24.0991 25.2377L25.5486 29.7032L21.7461 26.9407H26.4456L22.6496 29.7032Z",
          fill: "white"
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
